import { FormSelect, type SelectOption } from '@civilgrid/ui/components';
import type { Control, FieldValues, Path } from 'react-hook-form';

export interface SelectFieldProps<T extends FieldValues = FieldValues> {
  id: Path<T>;
  label: string;
  control: Control<T>;
  items: SelectOption[];
}

export default function SelectField<T extends FieldValues>({ id, label, control, items }: SelectFieldProps<T>) {
  return (
    <FormSelect
      name={id}
      control={control}
      label={label}
      options={items}
      validate={(value) => (value == null || value === '' ? `${label} is required` : true)}
      data-testid={`select-field-${id}`}
    />
  );
}
